import React from 'react';
import colors from '../../styles/colors';
import { StyledButton } from '../../styles/GenericStyled';

const FeaturedSectionView = ({ title, subtitle, label, button, setOpenRegister, children }) => (
  <div className="ui inverted vertical featured center aligned segment">
    <div className="segment cover">
      {children}
      <div className="ui container ctaplacement">
        <h1 className="ui inverted header">
          {title}
          {subtitle && (
            <span className="subtitle">
              <br />
              {subtitle}
            </span>
          )}
        </h1>
        <h3 className="ui inverted header" style={{ marginBottom: '10px' }}>
          {label}
        </h3>
        {button && (
          <StyledButton
            onClick={() => setOpenRegister(true)}
            type="secondary"
            mycolor={colors.ourWhite}
            mycolorhover={colors.ourBlack}
            background="bottom"
            backgroundhover={colors.ourWhite}
            border={1}
            bordercolor={colors.ourWhite}
          >
            {button.text}
          </StyledButton>
        )}
      </div>
    </div>
  </div>
);

const FeaturedSection = FeaturedSectionView;

export default FeaturedSection;
